const globals = {
    profile: 'Profile',
    logout: 'Sign out',
}

export default globals
